import { View } from 'components/View'
import { useTheme } from 'modules/styles'
import React from 'react'
import getStyleComponentUtil from 'modules/component/utils/get-style'

export default function Text (propParams) {
  const theme = useTheme()
  const {
    style,
    props
  } = getStyleAndProps(propParams, theme)
  return (
    <span {...props} style={style} />
  )
}

function getStyleAndProps (paramProps, theme) {
  const display = (
    paramProps.d || paramProps.display || paramProps.style?.display || 'inline'
  )

  let {
    style,
    props
  } = View.getStyleAndProps({
    ...paramProps,
    d: display
  }, theme)

  const color = props.c
  if (color) {
    style.color = theme.colors[color] || color
    delete props.c
  }

  const fontWeight = props.fw
  if (fontWeight) {
    style.fontWeight = fontWeight
    delete props.fw
  }

  const bold = props.b
  if (bold) {
    style.fontWeight = 'bold'
    delete props.b
  }

  const textAlign = props.ta
  if (textAlign) {
    style.textAlign = textAlign === true ? 'center' : textAlign
    style.display = 'inline-block'
    delete props.ta
  }

  const fontSize = props.fs
  if (fontSize) {
    style.fontSize = theme.fontSizes[fontSize] || fontSize
    delete props.fs
  }

  const lineHeight = props.lh
  if (lineHeight) {
    style.lineHeight = lineHeight
    delete props.lh
  }

  const numberOfLines = props.numberOfLines
  if (numberOfLines) {
    style = getStyleComponentUtil(style, {
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      WebkitLineClamp: `${typeof numberOfLines === 'number'
        ? numberOfLines
        : 'unset'}`
    })
    delete props.numberOfLines
  }

  return {
    style,
    props
  }
}

Text.getStyleAndProps = getStyleAndProps
